class Helper {
	static isObject (checkMe) {
		return checkMe && checkMe.constructor.name === 'Object';
	}

	static cloneObject (cloneMe) {
		let clone = {};

		for (let key in cloneMe) {
			if (cloneMe.hasOwnProperty(key)) {
				clone[key] = cloneMe[key];
			}
		}

		return clone;
	}

	static mergeObjects (...mergeUs) {
		let merged = {};
		for (let mergeMe of mergeUs) {
			for (let key in mergeMe) {
				if (mergeMe.hasOwnProperty(key)) {
					merged[key] = mergeMe[key];
				}
			}
		}

		return merged;
	}

	static getUrlParam (param) {
		const results = new RegExp('[?&]' + param + '=([^]*)').exec(window.location.href);
		if (results === null) {
			return null;
		} else {
			return results[1] || 0;
		}
	}

	static getParamsAsString (params) {
		const paramsArray = [];

		for (let key in params) {
			if (params.hasOwnProperty(key)) {
				if (typeof params[key] === 'function') {
					paramsArray.push(key + '=' + params[key]());
				} else {
					paramsArray.push(key + '=' + params[key]);
				}
			}
		}

		return paramsArray.join('&');
	}

	/**
	 * Checks if stage is live stage.
	 * @returns {boolean} If stage is 'live'.
	 */
	static isLiveStage () {
		return window.PageConfig.stage === 'live' || window.PageConfig.stage === 'prelive';
	}

	/**
	 * Checks if element is visible. implicit also checks its parents elements for visibility.
	 * @param {Element} element - The element to check.
	 * @returns {boolean} If the object is visible.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
	 */
	static isElementVisible (element) {
		return element.offsetParent !== null;
	}

	static getCookieValue (cookieName) {
		const findMe = '(?:^|; )' + cookieName + '=([^;]*)';
		return (document.cookie.match(findMe) || [0, ''])[1];
	}

	/**
	 * Creates a promise and starts XMLHttpRequest inside.
	 * @param {string} url The URL to call
	 * @param {'POST' | 'GET'} method The method to use for request
	 * @param {boolean} withCredentials Should credentials, e.g. cookies, be send with the request
	 * @returns {Promise<XMLHttpRequest>}
	 */
	static xhr (url, method = 'GET', withCredentials = true) {
		const request = new XMLHttpRequest();
		request.withCredentials = withCredentials;
		return new Promise((resolve, reject) => {
			request.onreadystatechange = function () {
				if (request.readyState !== 4) {
					return;
				}
				if (request.status >= 200 && request.status < 300) {
					resolve(request);
				} else {
					reject(request);
				}
			};
			request.open(method, url, true);
			request.send();
		});
	}
}

export { Helper };
